export enum CompanyRole {
  HQADMIN = 'HQADMIN',
  ACCOUNTHOLDER = 'ACCOUNTHOLDER',
  ADMIN = 'ADMIN',
}
